module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-3.168f24cb.png";